import Home from './Terms'

export default Home
